import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  InputAdornment,
  IconButton,
  Backdrop,
  Input,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useSettingContext } from '../../context/setting_context';
import { useClaimsContext } from '../../context/claims_context';
import { useAccountingContext } from '../../context/accounting_context';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
// import ClaimsView from './ClaimsView';
import ProviderSummary from '../reports/claimsnew/ProviderSummary';
import ProviderDetail from './ProviderDetail';
import ProviderTransactions from './ProviderTransactions';
import ProviderJournals from './ProviderJournals';

export default function ProviderAccount() {
  const [index, setIndex] = useState(0);
  const { getLimitUsage, getLimitTotalUsage, setClaimDetailsList } = useClaimsContext();
  const { doctor, setDoctor, setProviderId, providerId } = useSettingContext();
  const { refId, setRefId } = useAccountingContext();
  const [docSearchCode, setSearchCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  useEffect(() => {
    // getMemberInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabClicked = (event, index) => {
    setIndex(index);
  };

  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;

  const getProviderInfo = async (event) => {
    if (docSearchCode === '') {
      notifyPopup(`No AHFOZ # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/setting/GetProvider?namasNo=${docSearchCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Provider not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned doctor', result);
          setDoctor(result.data);
          setProviderId(result.data.provider_id);
          setRefId(result.data.provider_id);
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Medical Practise!: ${error}`, 'error');
      }
    );
  };

  const populateDependants = async (cifNumber) => {
    if (cifNumber === '') {
      return;
    }
    console.log('dependant cifnumber: ', cifNumber);
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetClientByAfcCifNo?afcNumber=${cifNumber}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Member not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned member', result);
          console.log('returned member cif', result.data.result);
          // setDependant(result.data.result);
          getLimitUsage(result.data.result);
          getLimitTotalUsage(result.data.result);
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Member!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid margin={2} container spacing={2} direction="row">
        <Grid item xs={3} sm={3} mr={2}>
          <FormControl>
            <InputLabel htmlFor="docSearchCodem">Search Provider</InputLabel>
            <Input
              id="docSearchCode"
              type="text"
              value={docSearchCode}
              onChange={(e) => {
                setSearchCode(e.target.value);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onMouseDown={handleMouseDownPassword}
                    onClick={() => getProviderInfo()}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel id="patientlbl">Patient</InputLabel>
            <Select
              id="patient_Cif_No"
              name="patient_Cif_No"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                populateDependants(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {dependantList.map((item) => (
                <MenuItem key={item.cif_number} value={item.cif_number}>
                  {item.suffix} {item.surname} {item.firstName}{' '}
                  {moment(item.dateOfBirth).isValid()
                    ? moment(item.dateOfBirth).format('YYYY-MM-DD')
                    : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
      </Grid>
      <Card>
        <CardContent>
          <AppBar position="static" color="darkblack">
            <Tabs
              value={index}
              indicatorColor="primary"
              // textColor="white"
              onChange={onTabClicked}
              aria-label="simple tabs example"
            >
              <Tab label="Provider Details" />
              <Tab label="Account Transactions" />
              <Tab label="Journals" />
            </Tabs>
          </AppBar>
          <Box>.</Box>
          <Panel value={index} index={0}>
            <ProviderDetail />
          </Panel>
          <Panel value={index} index={1}>
            {providerId > 0 && <ProviderTransactions />}
          </Panel>
          <Panel value={index} index={2}>
            {providerId > 0 && <ProviderJournals />}
          </Panel>
        </CardContent>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
